export default class TableBlock {
	private root: HTMLElement
	private btn: HTMLButtonElement | null
	private panel: HTMLElement | null
	private onClickBound: (e: MouseEvent) => void
	private onTransitionEndBound: (e: TransitionEvent) => void

	constructor(root: HTMLElement) {
		this.root = root
		this.btn = root.querySelector<HTMLButtonElement>('.hg-table-block__toggle')
		this.panel = root.querySelector<HTMLElement>('.hg-table-block__panel')
		this.onClickBound = this.onClick.bind(this)
		this.onTransitionEndBound = this.onTransitionEnd.bind(this)
	}

	init() {
		this.btn?.addEventListener('click', this.onClickBound)
		this.panel?.addEventListener('transitionend', this.onTransitionEndBound)
	}

	cleanup() {
		this.btn?.removeEventListener('click', this.onClickBound)
		this.panel?.removeEventListener('transitionend', this.onTransitionEndBound)
	}

	private refreshScroll() {
		document.dispatchEvent(new CustomEvent('hg:refresh-scroll'))
	}

	private syncLabel(expanded: boolean) {
		if (!this.btn) return
		const show = this.root.dataset.labelShow || ''
		const hide = this.root.dataset.labelHide || ''
		const text = expanded ? hide : show
		const labelSpan = this.btn.querySelector('span:not(.icon)')
		if (labelSpan) labelSpan.textContent = text
		this.btn.setAttribute('aria-expanded', expanded ? 'true' : 'false')
	}

	private onClick() {
		const expanded = !this.root.classList.contains('is-expanded')
		this.root.classList.toggle('is-expanded', expanded)
		this.syncLabel(expanded)
		if (expanded) {
			requestAnimationFrame(() => this.refreshScroll())
		}
	}

	private onTransitionEnd(e: TransitionEvent) {
		if (e.target !== this.panel) return
		if (e.propertyName !== 'grid-template-rows') return
		this.refreshScroll()
	}
}
